import * as React from 'react'
import PropTypes from 'prop-types'

export const isDark = theme => theme === 'Dark'
const ThemedSection = ({ children, theme }) => {
  let Wrapping = React.Fragment
  let className = ''
  switch (theme) {
    case 'Dark':
      Wrapping = 'div'
      className = 'bg-neutral-950 text-neutral-50'
      break
    case 'Light Gray':
      Wrapping = 'div'
      className = 'bg-neutral-200 '
      break
    case 'Tan':
      Wrapping = 'div'
      className = 'bg-[#f4e3d8]'
      break
    default:
      return children
  }
  return <Wrapping className={className}>{children}</Wrapping>
}

ThemedSection.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.string,
}

export default ThemedSection
